import React from 'react';
import { PieChart } from 'lucide-react';

const Earnings = () => {
  return (
    <div className="space-y-8 animate-in fade-in duration-700">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
        <div>
          <h1 className="text-2xl font-black text-gray-900 tracking-tight uppercase">Earnings</h1>
          <p className="text-xs sm:text-sm text-slate-500 mt-1">Track your revenue and payout settlements.</p>
        </div>
      </div>

      <div className="bg-white p-10 rounded-[3rem] border border-gray-100 shadow-sm flex flex-col items-center justify-center text-center space-y-6 py-32 min-h-[400px]">
        <div className="w-24 h-24 bg-gray-50 rounded-full flex items-center justify-center text-gray-200">
          <PieChart size={48} />
        </div>
        <div>
          <h2 className="text-xl font-black text-gray-900 uppercase tracking-tight">Earning Analytics</h2>
          <p className="text-[10px] font-black text-gray-400 mt-2 uppercase tracking-[0.2em] max-w-[300px] leading-relaxed">Payment and settlement tracking is coming soon to your experience portal.</p>
        </div>
        <div className="px-6 py-2.5 bg-emerald-50 rounded-xl text-emerald-600 font-black text-[10px] uppercase tracking-widest border border-emerald-100">
           Coming Soon
        </div>
      </div>
    </div>
  );
};

export default Earnings;
